export default {
    data() {
        return {
            idCard: '',
            studentName: '',
            //开始学习时间
            startTime: '',
            //结束学习时间
            endTime: '',
            //时长
            period: 0,
            //润沁名字
            trainingInstitution: '广州润沁教育科技有限公司',
            //认证年度
            year: '',
            //专业课数组
            proClass: [],
            //选修课数组
            avoClass: [],
            //最小的数
            minNum: -Infinity,
        }
    },
    methods: {
        //返回个人中心
        goWhere() {
            this.$router.push({
                path: 'personalcenter'
            })
        },

        getInfo: function () {
            //年度
            this.year = this.$route.query.year;
            
            //把2018-01-03=>[2018,01,03]分解
            let endDate = this.$route.query.end_date.substr(0, 10).split('-');
            // console.log(endDate);
            //结束时间
            this.endTime = endDate[0] + '年' + endDate[1] + '月' + endDate[2] + '日';
            //把2018-01-03=>[2018,01,03]分解
            let startDate = this.$route.query.pay_date.substr(0, 10).split('-');
            //开始时间
            this.startTime = startDate[0] + '年' + startDate[1] + '月' + startDate[2] + '日';
            //学生姓名
            this.studentName = this.$store.state.name;
            //请求订单项接口的发给后端的数据
            let data = {
                token: this.$store.state.id,
                ids: this.$route.query.goodId,
                offset: 0,
                length: 999
            }
            //根据订单项数据发送请求给后端
            this.$post('purchased/get_more', data).then(res => {
                for (let val of res.data.result.data) {
                     //算出几门课程完成的最晚时间作为结束时间
                    // let time = new Date((val.updated_at).replace(/-/g, "/")).getTime();
                    // if (time > this.minNum) {
                    //     let date = val.updated_at.substr(0, 10).split('-');
                    //     this.endTime = date[0] + '年' + date[1] + '月' + date[2] + '日';
                    //     this.minNum = time;
                    // }
                    //算出总学时
                    this.period += Number.parseFloat(val.period);
                    //专业课还是选修课，分成两个数组
                    if (val.attr == '专业课') {
                        this.proClass.push({name:val.product_name,period:val.period});
                        // console.log('proClass',this.proClass)
                    } else if (val.attr == '选修课') {
                        this.avoClass.push({name:val.product_name,period:val.period});
                        // console.log('avoClass',this.avoClass)
                    }
                }
                return true
            }).then(() => {
                //请求个人信息回来
                this.$post('users/profile', { token: this.$store.state.id }).then(res => {
                    this.studentName = res.data.result.name;
                    this.idCard = res.data.result.idcard;
                    return true;
                }).then(() => {
                    //生成canvas图片
                    var element = $("#html-content-holder");
                    var getCanvas;
                    html2canvas(element, {
                        onrendered: function (canvas) {
                            $("#previewImage").append(canvas);
                            getCanvas = canvas;
                        }
                    });
                    //点击下载图片事件
                    $("#btn-Convert-Html2Image").on("click", function () {
                        var imgageData = getCanvas.toDataURL("image/png");
                        var newData = imgageData.replace(
                            /^data:image\/png/,
                            "data:application/octet-stream"
                        );
                        $("#btn-Convert-Html2Image")
                            .attr("download", "学时证明.jpg")
                            .attr("href", newData);
                    });
                })
            })

        },
    },

    created(){
        this.getInfo();
        document.title = '学时证明';
 
    },
}